// 使用方法 ➔ 为不同元素指定独立配置
/*
<div class="shopify-section buy-bar-sticky"></div>
{% schema %}
{
  "name": "xxx",
  "class": "buy-bar-sticky",
  "settings": []
}
{% endschema %}

document.addEventListener('DOMContentLoaded', function() {
    const header = ...
    initSticky(container, { topOffset: 0, zIndex: 200 }, header)
})
*/

(function () {
    function throttle(fn, delay = 200) {
        let lastCall = 0;
        return function(...args) {
            const now = Date.now();
            if (now - lastCall >= delay) {
                fn.apply(this, args);
                lastCall = now;
            }
        }
    }



    const stickyManagerElements = []
    if (!window.initSticky) {
        window.initSticky = function (element, options = {}, header) {
            element.style.position = 'sticky'
            element.style.zIndex = options.zIndex || '3'
            element.style.top = '0px'
            element.style.transition = 'top 0.1s ease-in-out'
            element.dataset.topOffset = options.topOffset || 0
            stickyManagerElements.push(element)
            watchHeader(header)
        }
    }

    /* ===================== 滚动网页时，自动根据锚点的位置激活对应的Tab START ===================== */
    const viewportThreshold = window.innerHeight * 0.35;
    const anchors = document.querySelectorAll('.tab-anchor-item')
    function updateActiveTab() {
        const scrollPosition = window.scrollY;
        let activeAnchor = anchors[0];
        for (let i = anchors.length - 1; i >= 0; i--) {
            const rect = anchors[i].getBoundingClientRect();
            const anchorTop = rect.top + window.scrollY;

            // 当滚动位置超过锚点顶部+视口阈值的40%时激活
            if (scrollPosition > anchorTop - viewportThreshold) {
                activeAnchor = anchors[i];
                break;
            }
        }
        if (activeAnchor) {
            const anchorId = activeAnchor.getAttribute('id').replace('anchor-', '')
            const tab = document.querySelector(`li[data-anchor="${anchorId}"]`)
            if (tab) {
                tab.parentElement.querySelector('.active')?.classList.remove('active')
                tab.classList.add('active')
            }
        }
    }

    const throttledUpdate = throttle(updateActiveTab, 300);
    window.addEventListener('scroll', throttledUpdate);
    // 初始化时触发一次
    updateActiveTab();
    /* ===================== 滚动网页时，自动根据锚点的位置激活对应的Tab END ===================== */



    /* ===================== 监控header，实时调整浮动Tab栏的top位置 START ===================== */
    function updateElementsTop(top) {
        stickyManagerElements.forEach(el => {
            el.style.top = (top + parseInt(el.dataset.topOffset)) + 'px'
        })
    }

    let stickyManagerWatchIsInit = false
    function watchHeader(header) {
        if (header) {
            // 监控header的出现和隐藏，动态调整浮动栏的top偏移量
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        updateElementsTop(header.getBoundingClientRect().height)
                    } else {
                        updateElementsTop(0)
                    }
                });
            }, { threshold: [1] });
            observer.observe(header);


            // 监控header的高度变化
            const observerHeight = new ResizeObserver(entries => {
                for (let entry of entries) {
                    updateElementsTop(header.getBoundingClientRect().height)
                }
            });
            observerHeight.observe(header);

            stickyManagerWatchIsInit = true
        }
    }
    /* ===================== 监控header，实时调整浮动Tab栏的top位置 END ===================== */
})();




